import AnimatedSection from '../common/AnimatedSection'
import { servicesStrengths, servicesStrengthsSection } from '../../data/servicesPageData'

function ServicesStrengths() {
  const { eyebrow, titleLine1, titleAccent, description } = servicesStrengthsSection

  return (
    <AnimatedSection className="services-strengths-section">
      <div className="container corp-container">
        <header className="services-section-header services-section-header--center">
          <span className="section-label">{eyebrow}</span>
          <h2>
            {titleLine1} <span>{titleAccent}</span>
          </h2>
          <p>{description}</p>
        </header>

        <div className="row g-3 g-lg-4">
          {servicesStrengths.map((item) => {
            const Icon = item.icon
            return (
              <div className="col-6 col-md-4 col-xl-3" key={item.title}>
                <article className="services-strength-card">
                  <span className="services-strength-card__icon" aria-hidden="true">
                    <Icon />
                  </span>
                  <h3>{item.title}</h3>
                </article>
              </div>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ServicesStrengths
